import { httpClient } from '@/services/http/httpClient'

import type { User } from '@/services/http/usersService/types'

type UpdateAvatarParams = {
  avatar: File
}

export async function updateAvatar({
  avatar,
}: UpdateAvatarParams): Promise<{ user: User }> {
  const payload = new FormData()
  payload.append('file', avatar)

  const response = await httpClient.put(`/users/me/profile-image`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

  return response.data
}
